import { render } from "./Tenant.vue?vue&type=template&id=16d72800"
import script from "./Tenant.vue?vue&type=script&lang=ts"
export * from "./Tenant.vue?vue&type=script&lang=ts"
script.render = render

export default script